import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  buttonCancelSpacing: css`
    margin-left: 8px !important;
  `,
  searchContainer: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 16px 7px 16px 16px;
    color: ${colors.prussian};
  `,
  section: css`
    padding: 0px 16px;
    @media (max-width: 800px) {
      padding: 0px 8px;
    }
  `,
  tabHeaderSpacing: css`
    margin-top: 24px;
  `,
  searchForPadding: css`
    padding-bottom: 16px;
  `,
  content: css`
    flex-grow: 1;
  `,
  text: css`
    font-size: 13px;
    color: ${colors.prussian};
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: none;
    cursor: pointer;
  `,
  textSearch: css`
    padding-bottom: 16px;
  `,
  expiredFlyersSpacing: css`
    padding-top: 32px;
  `,
  viewExpiredButton: css`
    text-transform: none !important;
  `,
  dividerPadding: css`
    padding: 16px 0px;
  `,
  headerContainer: css`
    padding-bottom: 12px;
  `,
  currentFlyerHeader: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px 0px 12px;
    gap: 12px;
    /* padding-bottom: 12px; */
    & > * {
      display: flex;
      align-items: center;
    }
  `,
  buttonGrid: css`
    margin-left: auto;
  `,
  buttonViewModeExpired: css`
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
  `,
};

export default styles;
